import React, { FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import { Grid } from '@material-ui/core'

import Button from 'shared/components/Button'
import { Title, Text, Container } from './styles'
import { useOnboarding } from 'modules/pagamentos/hooks/useOnboarding'
import { colors } from 'shared/styles/colors'

interface CadastroFinalizadoProps {
  text?: string
}

const CadastroFinalizado: FunctionComponent<CadastroFinalizadoProps> = ({
  text,
}) => {
  const history = useHistory()
  const { setShowPercentualTransferencia } = useOnboarding()

  return (
    <Container>
      <Grid container>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Title>Cadastro finalizado! </Title>
          <Text>
            Seus dados foram enviados para análise. Eventualmente, poderemos
            solicitar documentos adicionais para aprovação da conta.
          </Text>
          <Text>
            Após a análise, se estiver tudo certo, sua conta estará pronta para
            usar!
          </Text>
          <Text>
            Enquanto isso, você pode definir as porcentagens de transferências
            para adiantamento, saldo, estadia e outros valores para o motorista.
            Ou confira as nossas ofertas de cargas.
          </Text>
        </Grid>
        <Grid container>
          <Button
            color={colors.green}
            onClick={() => setShowPercentualTransferencia(true)}
            style={{ width: '300px' }}
          >
            Definir porcentagens de transferência
          </Button>
          <Button
            color={colors.white}
            fontColor={colors.green}
            style={{
              border: `1px solid ${colors.green}`,
              marginLeft: 16,
              width: '200px',
            }}
            onClick={() => history.push('/lotes')}
          >
            Ver ofertas de cargas
          </Button>
        </Grid>
      </Grid>
    </Container>
  )
}

export default CadastroFinalizado
